export default "__VITE_ASSET__3c78091d__"